import React from 'react';
import './mirea-parts.css';

const ALLOWED_SRC = 'https://ischemes.ru/group/rtu-mirea/vern78';

export default function CampusMap({ props }) {
  if (props?.src !== ALLOWED_SRC) return null;
  return (
    <iframe
      className="mirea-campus-map"
      title={props.title || 'Проспект Вернадского, 78'}
      src={ALLOWED_SRC}
      loading="lazy"
      referrerPolicy="strict-origin-when-cross-origin"
    />
  );
}
